/*
Tools
*/
import filters from '@/modules/standardItems/schemas/shopSupplies/filters'
import headers from '@/modules/standardItems/schemas/shopSupplies/headers'

const name = 'Tools'
const id = '5LyLDwA6b2EFW3X5aEG1'

export default {
  name,
  id,
  filters,
  headers
}
